const htmlParaTextoPlano = (html) => {
    if (html === null || html === undefined) return "";

    const comQuebras = html
        .toString()
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/(p|div|li|h[1-6])>/gi, "\n");

    const documento = new DOMParser().parseFromString(comQuebras, "text/html");
    const texto = documento.body.textContent || "";

    return texto
        .replace(/\u00A0/g, " ")
        .replace(/[ \t]+\n/g, "\n")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
};

export default htmlParaTextoPlano;
